<template>
  <div id="Bid">
    <div class="bid_part1">
      <div class="part1_content flex_col">
        <div class="top flex">
          <div class="top_content flex_col">
            <div class="title flex_col">
              <span class="title queue-bottom">标讯查询</span>
            </div>
            <div class="title_content queue-bottom">
              通过应用大数据、人工智能技术为用户提供及时，准确的招投标信息，让用户可以轻松筛选有用标讯，把握商机。
            </div>
            <baseButton @btnAction="btnAction"/>
          </div>
        </div>
        <div class="bottom">
          <baskMask />
        </div>
      </div>
    </div>
    <div class="bid_part2">
      <div class="part2_content flex">
        <div>
          <span class="base_font queue-bottom" ref="part2_1">最新标讯</span>
          <p class="queue-bottom" ref="part2_2">
            免费获取实时更新招标/中标讯息，帮助企业快速了解商机
          </p>
        </div>
        <img src="@/assets/images/bid/part1.png" alt="" />
      </div>
    </div>
    <div class="bid_part3">
      <div class="part3_content flex">
        <img src="@/assets/images/bid/part2.png" alt="" />
        <div class="flex_col">
          <span class="base_font queue-bottom" ref="part3_1"
            >关键词订阅 商机不遗漏</span
          >
          <div class="part3_tips">
            <span class="base_font queue-bottom" ref="part3_2"
              >定制化关键词订阅及通知、收藏监控功能</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="bid_part4">
      <div class="part4_content flex">
        <div class="content">
          <span class="queue-bottom" ref="part4_1">项目追踪</span>
          <span style="font-size: 26px" class="queue-bottom" ref="part4_2"
            >监控招投标项目，了解最新动向进展</span
          >
        </div>
        <img src="@/assets/images/bid/part3.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import baskMask from '@/common/baseMask.vue'
import baseButton from '@/common/BaseBotton.vue'

export default {
  components: {
    baskMask,
    baseButton
  },
  data () {
    return {
    }
  },
  computed: {},
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll (e) {
      if (e.target.documentElement.scrollTop >= 750) {
        if (this.$refs.part2_1 && this.$refs.part2_2) {
          this.$refs.part2_1.style.display = 'block'
          this.$refs.part2_2.style.display = 'block'
        }
      }
      if (e.target.documentElement.scrollTop >= 1650) {
        if (this.$refs.part3_1 && this.$refs.part3_2) {
          this.$refs.part3_1.style.display = 'block'
          this.$refs.part3_2.style.display = 'block'
        }
      }
      if (e.target.documentElement.scrollTop >= 2450) {
        if (this.$refs.part4_1 && this.$refs.part4_2) {
          this.$refs.part4_1.style.display = 'block'
          this.$refs.part4_2.style.display = 'block'
        }
      }
    },
    btnAction () {
      this.$router.push({ path: '/bidList' })
    }
  }
}

</script>{
<style lang='scss' scoped>
#Bid {
  width: 100%;
  min-width: 1200px;
  .bid_part1 {
    padding-top: 261px;
    width: 100%;
    background: url(~assets/images/bid/bg1.png) no-repeat 50% 50%;
    background-size: cover;
    background-color: #000;
    .part1_content {
      width: 1200px;
      margin: auto;
      height: 100%;
      justify-content: space-between;
      .top {
        margin-left: 49px;
        .top_content {
          align-items: flex-start;
          flex: 1;
          .title {
            align-items: flex-start;
            span {
              font-size: 67px;
              font-weight: bold;
              line-height: 81px;
              color: #dbbb95;
              letter-spacing: 1px;
            }
          }
          .title_content {
            text-align: left;
            margin-top: 35px;
            font-size: 26px;
            font-weight: 400;
            line-height: 39px;
            color: #ffffff;
            max-width: 512px;
            margin-bottom: 40px;
          }
        }
      }
      .bottom {
        background: #161616;
        transform: translateY(220px);
      }
    }
  }
  .bid_part2 {
    width: 100%;
    background: url(~assets/images/bid/bg2.jpg) no-repeat 50% 50%;
    background-size: cover;
    padding-top: 247px;
    .part2_content {
      width: 1200px;
      margin: auto;
      justify-content: flex-end;
      & > div {
        padding-top: 163px;
        margin-right: 13px;
        span {
          max-width: 415px;
          display: none;
          margin-bottom: 19px;
        }
        p {
          font-size: 22px;
          font-weight: 400;
          line-height: 43px;
          color: #ffffff;
          max-width: 478px;
          display: none;
        }
      }
    }
  }
  .bid_part3 {
    width: 100%;
    background: url(~assets/images/bid/bg3.png) no-repeat 50% 50%;
    background-size: cover;
    padding-top: 89px;
    .part3_content {
      width: 1200px;
      margin: auto;
      & > div {
        align-items: flex-end;
        padding-top: 135px;
        margin-left: -28px;
        & > span {
          display: none;
          max-width: 335px;
        }
        .part3_tips {
          margin-top: 30px;
          span {
            display: none;
            font-size: 22px;
            font-weight: 400;
            line-height: 43px;
            color: #ffffff;
            max-width: 465px;
          }
        }
      }
    }
  }
  .bid_part4 {
    width: 100%;
    background: #fff;
    .part4_content {
      padding-top: 90px;
      width: 1200px;
      margin: auto;
      justify-content: flex-end;
      .content {
        padding-top: 98px;
        margin-right: 90px;
        span {
          display: none;
          font-size: 67px;
          font-weight: 400;
          line-height: 87px;
          color: #333333;
          max-width: 469px;
        }
        p {
          margin-top: 20px;
          font-size: 26px;
          font-weight: 400;
          line-height: 43px;
          color: #333333;
          max-width: 420px;
        }
      }
    }
  }
}
</style>
